import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noBanner from '../../../../../../public/img/image-not-found.png';
import {
  Container, Row, Col,
  Label, Input, InputGroup, CardLink,
  Card, CardImg, CardText, CardBody,
  CardTitle, CardSubtitle, Button, Badge,
  FormFeedback, Modal, ModalHeader, ModalBody, ModalFooter,
  UncontrolledTooltip,
  TabContent, TabPane, Nav, NavItem, NavLink,
} from 'reactstrap';

import ParadigmaModal from "../../../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../../../api";

import TabDetalle from './TabDetalle.js';
import TabBanner from './TabBanner.js';

class OfertasModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      descripcion: "",
      titulo: "",
      Imagen: "",
      articulos: [],
      code: '',

      postVariables: ['titulo', 'descripcion', 'articulos', 'Imagen'],
      errors: [],

      activeTab: props.activeTab ? props.activeTab : "1",
    };
    this.deleteImage = this.deleteImage.bind(this);
  }

  static propTypes = {
    onSubmit: PropTypes.func,
    id: PropTypes.func,
    action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
  }

  resetForm() {
    this.setState({
      code: '',
      titulo: "",
      descripcion: "",
      articulos: [],
      Imagen: "",
      errors: [],
      activeTab: this.props.activeTab ? this.props.activeTab : "1",
    });
  }

  getData() {
    const { postVariables } = this.state;
    let data = {};
    postVariables.forEach(x => {
      data[x] = this.state[x];
    });
    data.Imagen = (data.Imagen == noBanner ? "" : data.Imagen) 
    data.articulos.forEach((item) => {
      try {
        if (Number.isNaN(parseFloat(item.value)) == false) item.value = parseFloat(item.value);
      } catch (e) { }
    });

    return data;
  }

  setData(data) {
    if (data.success) {
      this.setState({
        code: data.code,
        titulo: data.Titulo,
        Imagen: data.Imagen != "" ? data.Imagen : "",
        descripcion: data.Descripcion,
        articulos: data.Articulos ? data.Articulos : [],
      })
    }
  }

  deleteImage() {
    this.setState({
      Imagen: "",
    });
  }

  setErrors(errors) {
    this.setState({
      errors: errors,
    });
  }

  onChangeField(field, value) {
    this.setState(prevState => {
      let errors = prevState.errors;
      if (errors) errors[field] = null;
      prevState.errors = errors;
      prevState[field] = value;
      return prevState;
    });
  }

  getError(field) {
    let errors = this.state.errors;
    if (errors) return errors[field];
    else return null;
  }

  modalVars() {
    const { action } = this.props;
    if (action == "CREATE") {
      return {
        get: false,
        submitType: "POST",
        title: "Nueva Lista de Ofertas",
        buttonTitle: "Nuevo",
        danger: false,
        saveButtonLabel: "Guardar",
        buttonIcon: "fa fa-plus fa-lg",
        successMessage: "La Lista de Ofertas ha sido creada con éxito.",
        saveButton: true,
        buttonClass: "",
        disabled: false,
      };
    } else if (action == "EDIT") {
      return {
        get: true,
        submitType: "PATCH",
        title: "Editar Lista de Ofertas",
        buttonTitle: "Editar",
        saveButtonLabel: "Guardar",
        danger: false,
        buttonIcon: "fa fa-pencil fa-lg",
        successMessage: "La Lista de Ofertas ha sido editada con éxito.",
        saveButton: true,
        buttonClass: "",
        disabled: false,
        id: this.props.id,
      };
    } else if (action == "DETAIL") {
      return {
        get: true,
        submitType: null,
        title: "Lista de Ofertas",
        buttonTitle: "Ver",
        danger: false,
        buttonIcon: "fa fa-search fa-lg",
        successMessage: "",
        saveButton: false,
        buttonClass: "",
        disabled: true,
        id: this.props.id,
      };
    } else if (action == "DELETE") {
      return {
        get: true,
        submitType: "DELETE",
        title: "Eliminar Lista de Ofertas",
        buttonTitle: "Eliminar",
        danger: true,
        saveButtonLabel: "Eliminar",
        buttonIcon: "fa fa-trash fa-lg",
        successMessage: "La Lista de Ofertas ha sido eliminada con éxito.",
        saveButton: true,
        buttonClass: "btn-danger",
        disabled: true,
        id: this.props.id,
      };
    } else if (action == "BANNER") {
      return {
        get: true,
        submitType: "PATCH",
        title: "Editar Lista de Ofertas",
        buttonTitle: "Banner",
        saveButtonLabel: "Guardar",
        danger: false,
        buttonIcon: "fa fa-picture-o fa-lg",
        successMessage: "La Lista de Ofertas ha sido editada con éxito.",
        saveButton: true,
        buttonClass: "",
        disabled: false,
        id: this.props.id,
      }
    }
  }

  render() {
    let vars = this.modalVars();
    const toggleTab = (idx) => this.setState({ activeTab: idx });
    const { action, id } = this.props;
    const id_item = id() && action != "CREATE" ? id() : 0;

    return (
      <ParadigmaModal
        getUrl={(vars.get ? api.gestion.articulos.ofertas.ofertas : null)}
        submitUrl={(vars.submitType ? api.gestion.articulos.ofertas.ofertas : null)}
        submitType={vars.submitType}
        id={vars.id}
        className={action != "DELETE" ? "modal-xl" : "modal-lg"}
        onGotData={(data) => this.setData(data)}
        onGotErrors={(errors) => this.setErrors(errors)}
        onSubmit={(e) => this.props.onSubmit(e)}
        onClose={() => this.resetForm()}
        onPreSubmit={() => this.getData()}

        title={vars.title}

        danger={vars.danger}
        buttonClass={vars.buttonClass}

        successMessage={vars.successMessage}
        missingIdMessage={"Debe seleccionar una fila."}

        saveButtonLabel={vars.saveButtonLabel}
        buttonTitle={vars.buttonTitle}
        buttonIcon={vars.buttonIcon}
        saveButton={vars.saveButton}
        closeButton={true}
      >
        <Nav tabs>
          <NavItem>
            <NavLink
              onClick={() => toggleTab('1')}
              className={this.state.activeTab == "1" ? "active" : ""}
            >
              <i class="fa fa-info" aria-hidden="true"></i> Detalle
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              onClick={() => toggleTab('2')}
              className={this.state.activeTab == "2" ? "active" : ""}
            >
              <i class="fa fa-picture-o" aria-hidden="true"></i> Banner
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabDetalle
            vars={vars}
            getError={(...data) => this.getError(...data)}
            onChangeField={(...data) => this.onChangeField(...data)}
            data={{
              id_item: id_item,
              action: action,
              titulo: this.state.titulo,
              descripcion: this.state.descripcion,
              articulos: this.state.articulos,
            }}
          />
          <TabBanner
            vars={vars}
            onChangeField={(...data) => this.onChangeField(...data)}
            data={{
              Imagen: this.state.Imagen,
            }}
            onDeleteImage={this.deleteImage}
            action={action}
          />
        </TabContent>
      </ParadigmaModal>
    );
  }
}

export default OfertasModal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Ofertas/ModalOfertas/Modal.js